import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { metricSelector, selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { supportedMetricsSelector } from '@store/common/selectors';
import { MetricSelectorPopup } from '@src/components/common';
import { setMetrics } from '@store/metricsChartContainer/actions';
import { preserveOrder } from '@components/common/DnD/utils';
import { refreshTrends } from '@store/common/actions';
import { useSetAtom } from 'jotai';
import { diagnosticsModeAtom } from '../atoms';
import { isAppModule } from '@utils/constants';

const MetricsPopup = () => {
  const dispatch = useDispatch();
  const selectedMetricsFromStore = useSelector(metricSelector);
  const selectedTrendMetric = useSelector(selectedMetricSelector);
  const supportedMetrics = useSelector(supportedMetricsSelector);

  const setDiagnosticsMode = useSetAtom(diagnosticsModeAtom);

  const [selectedMetrics, setSelectedMetrics] = useState(selectedMetricsFromStore);

  const onApply = (metrics, kpiChanged) => {
    dispatch(setMetrics(preserveOrder(selectedMetricsFromStore, metrics)));

    // refresh data on page
    if (kpiChanged) {
      dispatch(refreshTrends());
    }
    // disable diagnostics mode when metric changes are applied
    setDiagnosticsMode(false);
  };

  React.useEffect(() => {
    setSelectedMetrics(selectedMetricsFromStore);
  }, [selectedMetricsFromStore]);

  return (
    <MetricSelectorPopup
      supportedMetrics={supportedMetrics}
      selectedMetrics={selectedMetrics}
      lockedMetrics={[selectedTrendMetric]}
      onApply={onApply}
      metricsCountLimit={isAppModule ? 20 : 999}
    />
  );
};

export default React.memo(MetricsPopup);
